import React from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router';

const FreeAuthRoute = ({ auth, children }) => {
// console.log(localStorage.getItem('accessToken'),"auuth")
  if(localStorage.getItem('accessToken') || auth.user) {
    return <Navigate to="/dashboard" />
  }
  return children;
}

const mapStateToProps = state => {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, null)(FreeAuthRoute);